import { takeEvery } from 'redux-saga/effects';
import { getQcsSyncResources } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import { getLastSyncDate } from './investmentQuotesV2Selectors';
import { mkInvestmentQuoteV2 } from './investmentQuotesV2Types';
import * as actions from './investmentQuotesV2Actions';

export function* getInvestmentQuotesActionWatcher(): Generator<*, *, *> {
  const config = mkQcsSyncResourceConfig({
    resourceName: 'investment quotes',
    resourceBaseUrl: '/v2/investments/quotes',
    getLastSyncDate,
    successAction: actions.getInvestmentQuotesV2Success,
    failureAction: actions.getInvestmentQuotesV2Failure,
    transformResponseToResources: (response) => response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentQuoteV2({
      ...data,
      id: data.symbol,
    })),
  });
  yield takeEvery(actions.getInvestmentQuotesV2, getQcsSyncResources, config);
}

export default [
  getInvestmentQuotesActionWatcher,
];
